/**
 * @Author: wanghaowh.wang
 * @Date:   2018-02-13T21:08:54+08:00
 * @Email:  wanghaowh.wang@qunar.com
 * @Filename: index.js
 * @Last modified by:   wanghaowh.wang
 * @Last modified time: 2018-02-13T21:22:54+08:00
 * @Description:
 */

'use strict';

require('../css/index.scss');

var debounce = require('lodash/debounce'),
    notificationTpl = require('./notification.mustache');

var config = {
    login: '/user/identify.php',
    checkUsername: '/user/check_username.php',
    sendActiveCode: '/user/send_active_code.php',
    register: '/user/register.php',
    userManage: '/user/index'
};

function getQueryString(name) {
    var query = location.search.slice(1),
        re = new RegExp(name + '=([^&$]+)'),
        match = query.match(re);

    if (match) {
        return decodeURIComponent(match[1]);
    }
}

var page = {
    init: function() {
        var self = this;

        self.$loginError = $('#js-login-error');
        self.$loginForm = $('#js-login');
        self.$registerForm = $('#js-register');
        self.$loginBtn = $('#js-login-btn');
        self.$registerBtn = $('#js-register-btn');
        self.$tab = $('.js-tab');
        self.$code = $('#js-code');
        self.$successAlert = $('#js-success-alert');
        self.canSubmit = false;
        self.canSendActiveCode = true;

        self.$resetPasswdDialog = $('#js-resetPasswdDialog');

        self.$notification = $('#js-notification');

        self.bindEvents();

        self.loadNotification();
    },
    bindEvents: function() {
        var self = this;

        self.$resetPasswdDialog.on('click', '#js-confirm-reset', function(e) {
            e.preventDefault();
            self.validForm(self.$resetPasswdDialog.find('input'));

            if (self.canSubmit) {
                self.$resetPasswdDialog.modal('hide');
                $.ajax({
                    url: '/user/fogot.php',
                    type: 'POST',
                    dataType: 'json',
                    data: self.$resetPasswdDialog.find('form').serialize(),
                    success: function(data) {
                        var $modalText = self.$successAlert.find('modal-body');
                        if (data && data.result) {
                            $modalText.text('密码重置成功');
                        } else {
                            $modalText.text('密码重置失败');
                        }
                        self.$successAlert.modal();
                        data && data.result && setTimeout(function() {
                            self.$successAlert.modal('hide');
                        }, 2000);
                    }
                });
            }
        });

        self.$tab.on('click', function() {
            var $this = $(this),
                type = $this.data('type');
            $this.addClass('active').siblings().removeClass('active');
            $('#js-' + type).removeClass('hide').siblings('.login-body').addClass('hide');
        });

        self.$loginForm.on('submit', function(e) {
            e.preventDefault();
            $.ajax({
                url: config.login,
                type: 'POST',
                dataType: 'json',
                data: self.$loginForm.serialize(),
                success: function(data) {
                    if (data && data.result === 'verified') {
                        self.jump();
                    } else {
                        self.$loginError.removeClass('hide');
                    }
                }
            });
        }).on('input', 'input', function() {
            if (!self.$loginError.hasClass('hide')) {
                self.$loginError.addClass('hide');
            }
        });


        self.$registerForm.on('submit', function(e) {
            e.preventDefault();
            self.validForm(self.$registerForm.find('.js-validate'));

            if (!self.canSubmit) {
                return;
            }
            $.ajax({
                url: config.register,
                type: 'POST',
                dataType: 'json',
                data: self.$registerForm.serialize(),
                success: function(data) {
                    if (data && data.result) {
                        self.jump();
                    }
                }
            });
        }).on('click', '#js-refresh-code', function() {
            self.$code.attr('src', config.refreshCode)
        }).on('click', '#js-active-code', function(e) {
            e.preventDefault();
            var $this = $(this);

            self.validForm($('#mobile'));
            if (!self.canSubmit) {
                return;
            }
            self.sendActiveCode($this);
        }).on('input', '#user_name', debounce(
            self.checkUsernameValid, 500, { trailing: true })
        ).on('change', 'input', function() {
            var $this = $(this),
                needRemote = $this.data('remote');

            self.validForm($this, needRemote);
        });
    },
    jump: function() {
        var ret = getQueryString('ret');
        var referrer = document.referrer;
        if (ret === 'back' || referrer) {
            history.back();
            return;
        } else if (ret) {
            location.replace(ret);
            return;
        }
        location.href = config.userManage;
    },
    initSwiper: function() {
        var self = this;

        self.swiper = new Swiper(self.$notification[0], {
            autoplay: {
                disableOnInteraction: false,
                delay: 5000
            },
            speed: 500,
            effect: 'cube',
            cubeEffect: {
                slideShadows: false,
                shadow: false
            },
            pagination: {
                el: '#js-pagination',
                clickable: true
            }
        });
    },
    loadNotification: function() {
        var self = this;
        $.ajax({
            url: '/user/notification.php',
            type: 'GET',
            dataType: 'json',
            success: function(res) {
                if (res && res.length) {
                    self.$notification.html(notificationTpl({data: res}));

                    res.length > 1 && self.initSwiper();
                }
            }
        })
    },
    checkUsernameValid: function() {
        var $input = $(this),
            $row = $input.closest('.row');
        $.ajax({
            url: config.checkUsername,
            type: 'POST',
            dataType: 'json',
            data: {
                username: $input.val()
            },
            success: function(data) {
                if (data && data.result) {
                    $row.addClass('has-exist');
                    self.canSubmit = false;
                } else {
                    $row.removeClass('has-exist');
                    self.canSubmit = true;
                }
            }
        });
    },
    validForm: function($input, needRemote) {
        var self = this;

        if ($input) {
            var $row = $input.closest('.row'),
                type = $input.data('type'),
                content = $input.val();

            if (needRemote) {
                $.ajax({
                    url: '/user/check_inputsyntax.php',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        type: type,
                        content: content
                    },
                    success: function(data) {
                        if (data && data.result) {
                            $row.removeClass('has-error');
                            self.canSubmit = true;
                        } else {
                            $row.addClass('has-error');
                            self.canSubmit = false;
                        }
                    }
                });
                return;
            }

            var minlength = parseInt($input.attr('minlength'), 10);
            if (minlength && $.trim($input.val()).length < minlength) {
                $row.addClass('has-error');
                self.canSubmit = false;
                return;
            }
        }

        $.each($input || self.$registerForm.find('input'), function(index, input) {
            var $row = $(input).closest('.row');
            if (!input.value) {
                $row.addClass('has-error');
                self.canSubmit = false;
                return false;
            }
            $row.removeClass('has-error');
            self.canSubmit = true;
        });
    },
    sendActiveCode: function($sendActiveCodeBtn) {
        var self = this;

        if (!self.canSendActiveCode) {
            return;
        }

        $.ajax({
            url: config.sendActiveCode,
            type: 'POST',
            dataType: 'json',
            data: {
                mobile: $('#mobile').val()
            },
            success: function(data) {
                if (data && data.result) {
                    // 发送成功，暂停一分钟才能再次发送
                    self.countDown(function(sec) {
                        self.canSendActiveCode = false;
                        $sendActiveCodeBtn.prop('disabled', true).text('已发送到手机(' + sec + ')');
                    }, function(sec) {
                        self.canSendActiveCode = true;
                        $sendActiveCodeBtn.prop('disabled', false).text('发送激活码');
                    }, 60);
                }
            }
        })
    },
    countDown: function(processFn, successFn, sec) {
        if (sec <= 0) {
            successFn(sec);
            return;
        }
        var self = this;
        processFn(sec);
        setTimeout(function() {
            self.countDown(processFn, successFn, --sec);
        }, 1000);
    }
};

page.init();



//////////////////
// WEBPACK FOOTER
// ./src/js/index.js
// module id = vGYV
// module chunks = 0